import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

function isValidSupabaseUrl(value) {
  try {
    const url = new URL(value);
    return /^https?:$/.test(url.protocol) && !value.includes('your_supabase_project_url');
  } catch {
    return false;
  }
}

export const isSupabaseConfigured = Boolean(
  isValidSupabaseUrl(supabaseUrl) &&
  supabaseAnonKey &&
  !supabaseAnonKey.includes('your_supabase_anon_key')
);

if (import.meta.env.DEV && !isSupabaseConfigured) {
  console.error(
    'Supabase is not configured. Add a valid VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY to .env.'
  );
}

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: 'pkce'
      }
    })
  : null;
// A sync operation keeps the verified account's bearer token even if another
// tab signs into a different account while a receipt is uploading.
export function clientForAccessToken(token) {
  return createClient(supabaseUrl, supabaseAnonKey, {
    global: {headers: {Authorization: `Bearer ${token}`}},
    auth: {persistSession: false, autoRefreshToken: false, detectSessionInUrl: false}
  });
}

